import UserEditInfoModal from './UserEditInfoModal';

export default UserEditInfoModal;
